import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { createHead } from '@vueuse/head'

const app = createApp(App as any)
const head = createHead()

app.use(router)
app.use(vuetify)
app.use(head)

app.mount('#app')